import React from 'react';
import { Component } from 'react';
const fallbackUI = () => React.createElement(React.Fragment, null);
// Error Boundary which handles errors both in SSR and Client Rendering
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: undefined,
            errorInfo: undefined,
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true, error, errorInfo });
    }
    // renderServer(): RenderType {
    //   const { renderFallbackUI = fallbackUI, children: child } = this.props;
    //   try {
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //     const children = renderToString(child);
    //     return child;
    //   } catch (e) {
    //     return renderFallbackUI(e);
    //   }
    // }
    render() {
        const { renderFallbackUI = fallbackUI, 
        // isServer = false,
        children, } = this.props;
        const { hasError, error, errorInfo, } = this.state;
        // commenting out for now. Causing issue in SSR
        // // this is the ErrorBoundary in SSR
        // if (isServer) {
        //   return this.renderServer();
        // }
        // this is the ErrorBoundary in Client Rendering
        if (hasError) {
            return renderFallbackUI(error, errorInfo);
        }
        return children;
    }
}
export default ErrorBoundary;
